import { z } from 'zod';
import { OwnerStatus } from '@/features/owners/types/owners-dto';

export const OwnersPageFilterFormSchema = z.object({  
  apartmentId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  ownerId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  ownerStatus: z
    .nativeEnum(OwnerStatus)
    .nullable()
    .optional(),
});